import apiService from './api';

export const advertisementService = {
  // Get all advertisements (Admin)
  getAllAdvertisements: async () => {
    return await apiService.getAllAdvertisements();
  },

  // Get pending advertisements (Admin)
  getPendingAdvertisements: async () => {
    return await apiService.getPendingAdvertisements();
  },

  // Approve advertisement (Admin)
  approveAdvertisement: async (advertisementId) => {
    return await apiService.approveAdvertisement(Number(advertisementId));
  },

  // Reject advertisement (Admin)
  rejectAdvertisement: async (advertisementId, rejectionReason) => {
    return await apiService.rejectAdvertisement(advertisementId, rejectionReason);
  },

  // Add design to advertisement (Admin)
  addDesign: async (formData) => {
    return await apiService.addDesign(formData);
  },

  // Get advertisement designs (Admin)
  getAdvertisementDesigns: async (advertisementId) => {
    return await apiService.getAdvertisementDesigns(advertisementId);
  },

  // Delete design (Admin)
  deleteDesign: async (designId) => {
    return await apiService.deleteDesign(designId);
  },

  // Get advertisement statistics (Admin)
  getStatistics: async () => {
    return await apiService.getAdvertisementStatistics();
  },

  // Get active advertisements (Public)
  getActiveAdvertisements: async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements`);
    return await response.json();
  },

  // Get advertisement packages (Public)
  getPackages: async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements/packages`);
    return await response.json();
  },

  // Create advertisement (Service Provider)
  createAdvertisement: async (formData) => {
    const token = localStorage.getItem('admin_token');
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });
    return await response.json();
  },

  // Get user's advertisements (Service Provider)
  getUserAdvertisements: async () => {
    const token = localStorage.getItem('admin_token');
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements/my-advertisements`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return await response.json();
  },

  // Select package (Service Provider)
  selectPackage: async (advertisementId, packageId) => {
    const token = localStorage.getItem('admin_token');
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements/select-package`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        advertisement_id: advertisementId,
        package_id: packageId,
      }),
    });
    return await response.json();
  },

  // Simulate payment (Service Provider)
  simulatePayment: async (advertisementId) => {
    const token = localStorage.getItem('admin_token');
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements/simulate-payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        advertisement_id: advertisementId,
      }),
    });
    return await response.json();
  },

  // Track advertisement view (Public)
  trackView: async (advertisementId) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements/track-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        advertisement_id: advertisementId,
      }),
    });
    return await response.json();
  },

  // Track advertisement click (Public)
  trackClick: async (advertisementId) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://app-api.spinndo.com/api'}/advertisements/track-click`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        advertisement_id: advertisementId,
      }),
    });
    return await response.json();
  },

  // Create advertisement (Admin)
  createAdvertisement: async (formData) => {
    return await apiService.createAdvertisement(formData);
  },

  // Update advertisement (Admin)
  updateAdvertisement: async (advertisementId, formData) => {
    return await apiService.updateAdvertisement(advertisementId, formData);
  },

  // Delete advertisement (Admin)
  deleteAdvertisement: async (advertisementId) => {
    return await apiService.deleteAdvertisement(advertisementId);
  },
};
